<template>
  <template v-if="!showPreview">
    <q-card class="social-feed-card" :class="{'social-feed-card--expanded': props.expanded}">
      <q-card-section>
        <!-- Header with platform info -->
        <div class="header row items-center justify-between no-wrap">
        <!-- <div class="row items-start no-wrap">  -->
          
          <q-avatar class="platform-icon" rounded> 

            <svg v-if="feedItem.platform === 'bluesky'"
              :aria-label="feedItem.platform"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 600 530"
              preserveAspectRatio="xMidYMid meet"
            >
              <title>Bluesky</title>
              <path 
                d="m135.72 44.03c66.496 49.921 138.02 151.14 164.28 205.46 26.262-54.316 97.782-155.54 164.28-205.46 47.98-36.021 125.72-63.892 125.72 24.795 0 17.712-10.155 148.79-16.111 170.07-20.703 73.984-96.144 92.854-163.25 81.433 117.3 19.964 147.14 86.092 82.697 152.22-122.39 125.59-175.91-31.511-189.63-71.766-2.514-7.3797-3.6904-10.832-3.7077-7.8964-0.0174-2.9357-1.1937 0.51669-3.7077 7.8964-13.714 40.255-67.233 197.36-189.63 71.766-64.444-66.128-34.605-132.26 82.697-152.22-67.108 11.421-142.55-7.4491-163.25-81.433-5.9562-21.282-16.111-152.36-16.111-170.07 0-88.687 77.742-60.816 125.72-24.795z" 
                fill="#1185fe"
              />
            </svg>

            <svg v-else-if="feedItem.platform === 'zenodo'"
              :aria-label="feedItem.platform"
              role="img"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 220 80"
              enable-background="new 0 0 220 80"
              xml:space="preserve"
              preserveAspectRatio="xMidYMid meet"
            >
              <title>Zenodo</title>
              <linearGradient id="zenodo-gradient" gradientUnits="userSpaceOnUse" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop stop-color="#0047A8" offset="0"/>
                <stop stop-color="#2BBCFF" offset="1"/>
              </linearGradient>
              <rect x="0" y="0" width="220px" height="80px" fill="url(#zenodo-gradient)" />
              <g transform="translate(36.5, 10)">
                <path 
                  fill="#FFFFFF"
                  d="M145.301,18.875c-0.705-1.602-1.656-2.997-2.846-4.19c-1.189-1.187-2.584-2.125-4.188-2.805 c-1.604-0.678-3.307-1.02-5.102-1.02c-1.848,0-3.564,0.342-5.139,1.02c-0.787,0.339-1.529,0.74-2.225,1.205 c-0.701,0.469-1.357,1.003-1.967,1.6c-0.377,0.37-0.727,0.761-1.051,1.17c-0.363,0.457-0.764,1.068-0.992,1.439 c-0.281,0.456-0.957,1.861-1.254,2.828c0.041-1.644,0.281-4.096,1.254-5.472V2.768c0-0.776-0.279-1.431-0.84-1.965 C120.396,0.268,119.75,0,119.021,0c-0.777,0-1.43,0.268-1.969,0.803c-0.531,0.534-0.801,1.189-0.801,1.965v10.569
                  c-1.117-0.778-2.322-1.386-3.605-1.824c-1.285-0.436-2.637-0.654-4.045-0.654c-1.799,0-3.496,0.342-5.1,1.02 c-1.605,0.679-3,1.618-4.195,2.805c-1.186,1.194-2.139,2.588-2.836,4.19c-0.053,0.12-0.1,0.242-0.15,0.364 c-0.047-0.122-0.094-0.244-0.146-0.364c-0.705-1.602-1.656-2.997-2.846-4.19c-1.189-1.187-2.586-2.125-4.188-2.805 c-1.604-0.678-3.307-1.02-5.102-1.02c-1.848,0-3.564,0.342-5.139,1.02c-1.584,0.679-2.979,1.618-4.191,2.805 c-1.213,1.194-2.164,2.588-2.842,4.19c-0.049,0.115-0.092,0.23-0.137,0.344c-0.047-0.114-0.092-0.229-0.141-0.344
                  c-0.701-1.602-1.65-2.997-2.84-4.19c-1.191-1.187-2.588-2.125-4.193-2.805c-1.604-0.678-3.301-1.02-5.104-1.02 c-1.842,0-3.557,0.342-5.137,1.02c-1.578,0.679-2.977,1.618-4.186,2.805c-1.221,1.194-2.166,2.588-2.848,4.19
                  c-0.043,0.106-0.082,0.214-0.125,0.32c-0.043-0.106-0.084-0.214-0.131-0.32c-0.707-1.602-1.656-2.997-2.848-4.19 c-1.188-1.187-2.582-2.125-4.184-2.805c-1.605-0.678-3.309-1.02-5.104-1.02c-1.85,0-3.564,0.342-5.137,1.02 c-1.467,0.628-2.764,1.488-3.91,2.552V13.99c0-1.557-1.262-2.822-2.82-2.822H3.246c-1.557,0-2.82,1.265-2.82,2.822 c0,1.559,1.264,2.82,2.82,2.82h15.541L0.557,41.356C0.195,41.843,0,42.433,0,43.038v1.841c0,1.558,1.264,2.822,2.822,2.822 h21.047c1.488,0,2.705-1.153,2.812-2.614c0.932,0.743,1.967,1.364,3.109,1.848c1.605,0.684,3.299,1.021,5.102,1.021
                  c2.723,0,5.15-0.726,7.287-2.187c1.727-1.176,3.092-2.639,4.084-4.389v3.805c0,0.778,0.264,1.436,0.805,1.968 c0.531,0.537,1.189,0.803,1.967,0.803c0.73,0,1.369-0.266,1.93-0.803c0.561-0.532,0.838-1.189,0.838-1.968v-9.879h-0.01 c0-0.002,0.01-0.013,0.01-0.013s-6.137,0-6.912,0c-0.58,0-1.109,0.154-1.566,0.472c-0.463,0.316-0.793,0.744-0.982,1.275 l-0.453,0.93c-0.631,1.365-1.566,2.443-2.809,3.244c-1.238,0.803-2.633,1.201-4.188,1.201c-1.023,0-2.004-0.191-2.955-0.579 c-0.941-0.39-1.758-0.935-2.439-1.64c-0.682-0.703-1.227-1.52-1.641-2.443c-0.41-0.924-0.617-1.893-0.617-2.916v-2.476h17.715
                  h1.309h5.539v-8.385c0-1.015,0.191-1.99,0.582-2.912c0.389-0.922,0.936-1.74,1.645-2.444c0.699-0.703,1.514-1.249,2.441-1.641 c0.918-0.388,1.92-0.581,2.982-0.581c1.023,0,2.01,0.193,2.955,0.581c0.945,0.393,1.762,0.938,2.439,1.641 c0.682,0.704,1.225,1.521,1.641,2.444c0.412,0.922,0.621,1.896,0.621,2.912v21.208c0,0.778,0.266,1.436,0.799,1.968 c0.535,0.537,1.191,0.803,1.971,0.803c0.729,0,1.371-0.266,1.934-0.803c0.553-0.532,0.834-1.189,0.834-1.968v-3.803 c0.588,1.01,1.283,1.932,2.1,2.749c1.189,1.189,2.586,2.124,4.191,2.804c1.602,0.684,3.303,1.021,5.102,1.021
                  c1.795,0,3.498-0.337,5.102-1.021c1.602-0.68,3.01-1.614,4.227-2.804c1.211-1.19,2.162-2.589,2.842-4.189 c0.037-0.095,0.074-0.19,0.109-0.286c0.039,0.096,0.074,0.191,0.113,0.286c0.678,1.601,1.625,2.999,2.842,4.189 c1.213,1.189,2.607,2.124,4.189,2.804c1.574,0.684,3.293,1.021,5.139,1.021c1.795,0,3.5-0.337,5.105-1.021 c1.6-0.68,2.994-1.614,4.184-2.804c1.191-1.19,2.141-2.589,2.848-4.189c0.051-0.12,0.098-0.239,0.146-0.36 c0.049,0.121,0.094,0.24,0.146,0.36c0.703,1.601,1.652,2.999,2.842,4.189c1.189,1.189,2.586,2.124,4.191,2.804
                  c1.604,0.684,3.303,1.021,5.102,1.021c1.795,0,3.498-0.337,5.102-1.021c1.604-0.68,3.01-1.614,4.227-2.804 c1.211-1.19,2.16-2.589,2.842-4.189c0.678-1.606,1.02-3.306,1.02-5.104v-10.86C146.355,22.182,146.002,20.479,145.301,18.875z  M7.064,42.06l14.758-19.874c-0.078,0.587-0.121,1.184-0.121,1.791v10.86c0,1.799,0.35,3.498,1.059,5.104 c0.328,0.752,0.719,1.458,1.156,2.119c-0.016,0-0.031-0.001-0.047-0.001H7.064z M42.541,26.817H27.24v-2.841 c0-1.015,0.189-1.99,0.58-2.912c0.391-0.922,0.936-1.74,1.645-2.444c0.697-0.703,1.516-1.249,2.438-1.641
                  c0.922-0.388,1.92-0.581,2.99-0.581c1.02,0,2.002,0.193,2.949,0.581c0.949,0.393,1.764,0.938,2.441,1.641 c0.682,0.704,1.225,1.521,1.641,2.444c0.414,0.922,0.617,1.896,0.617,2.912V26.817z M91.688,34.837 c0,1.023-0.189,1.992-0.582,2.916c-0.389,0.924-0.936,1.74-1.637,2.443c-0.705,0.705-1.523,1.25-2.445,1.64 c-0.92,0.388-1.92,0.579-2.984,0.579c-1.023,0-2.004-0.191-2.955-0.579c-0.945-0.39-1.758-0.935-2.439-1.64 c-0.682-0.703-1.229-1.52-1.641-2.443s-0.617-1.893-0.617-2.916v-10.86c0-1.015,0.191-1.99,0.582-2.912 c0.387-0.922,0.934-1.74,1.639-2.444c0.701-0.703,1.52-1.249,2.441-1.641c0.922-0.388,1.92-0.581,2.99-0.581
                  c1.018,0,2.004,0.193,2.947,0.581c0.951,0.393,1.764,0.938,2.443,1.641c0.68,0.704,1.223,1.521,1.641,2.444 c0.412,0.922,0.617,1.896,0.617,2.912V34.837z M116.252,34.837c0,1.023-0.203,1.992-0.617,2.916 c-0.412,0.924-0.961,1.74-1.641,2.443c-0.68,0.705-1.492,1.25-2.443,1.64c-0.943,0.388-1.93,0.579-2.949,0.579 c-1.07,0-2.066-0.191-2.988-0.579c-0.924-0.39-1.74-0.935-2.439-1.64c-0.707-0.703-1.252-1.52-1.643-2.443 s-0.584-1.893-0.584-2.916v-10.86c0-1.015,0.211-1.99,0.619-2.912c0.416-0.922,0.961-1.74,1.641-2.444 c0.682-0.703,1.496-1.249,2.439-1.641c0.951-0.388,1.934-0.581,2.955-0.581c1.068,0,2.062,0.193,2.986,0.581
                  c0.926,0.393,1.738,0.938,2.443,1.641c0.703,0.704,1.252,1.521,1.641,2.444c0.389,0.922,0.58,1.896,0.58,2.912V34.837z  M140.816,34.837c0,1.023-0.193,1.992-0.58,2.916c-0.393,0.924-0.939,1.74-1.641,2.443c-0.705,0.705-1.523,1.25-2.443,1.64 c-0.922,0.388-1.92,0.579-2.986,0.579c-1.021,0-2.004-0.191-2.955-0.579c-0.943-0.39-1.758-0.935-2.438-1.64 c-0.682-0.703-1.23-1.52-1.643-2.443s-0.619-1.893-0.619-2.916v-10.86c0-1.015,0.193-1.99,0.584-2.912 c0.387-0.922,0.934-1.74,1.639-2.444c0.703-0.703,1.518-1.249,2.441-1.641c0.924-0.388,1.92-0.581,2.99-0.581
                  c1.02,0,2.004,0.193,2.949,0.581c0.949,0.393,1.764,0.938,2.441,1.641c0.682,0.704,1.225,1.521,1.643,2.444 c0.412,0.922,0.617,1.896,0.617,2.912V34.837z"
                />
              </g>
            </svg>

            <svg v-else-if="feedItem.platform === 'zotero'"
              :aria-label="feedItem.platform"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 108 32"
              preserveAspectRatio="xMidYMid meet"
            >
              <title>Zotero</title>
              <g>
                <path d="M15.541,8.359,4.032,23.48H15.96V26H0V23.983L11.507,8.863H.588V6.344H15.541Z" fill="#db2c3a"/>
                <path d="M38.135,16.172a10.743,10.743,0,0,1-.776,4.116,9.743,9.743,0,0,1-5.46,5.439,11.132,11.132,0,0,1-4.222.777,11.006,11.006,0,0,1-4.178-.777,9.743,9.743,0,0,1-5.46-5.439,10.706,10.706,0,0,1-.778-4.116,10.7,10.7,0,0,1,.778-4.116A9.735,9.735,0,0,1,23.5,6.617a10.987,10.987,0,0,1,4.178-.778,11.113,11.113,0,0,1,4.222.778,9.735,9.735,0,0,1,5.46,5.439A10.739,10.739,0,0,1,38.135,16.172Zm-3.023,0a8.816,8.816,0,0,0-.526-3.066A7.355,7.355,0,0,0,33.1,10.628a7,7,0,0,0-2.331-1.659,8.116,8.116,0,0,0-6.174,0,6.775,6.775,0,0,0-2.309,1.659,7.558,7.558,0,0,0-1.47,2.478,9.212,9.212,0,0,0,0,6.131,7.532,7.532,0,0,0,1.47,2.479,6.775,6.775,0,0,0,2.309,1.659,8.141,8.141,0,0,0,6.174,0A7,7,0,0,0,33.1,21.716a7.33,7.33,0,0,0,1.491-2.479A8.807,8.807,0,0,0,35.112,16.172Z" fill="#222"/>
                <path d="M51.659,8.863h-5.67V20.456a6.294,6.294,0,0,0,.21,1.785,2.52,2.52,0,0,0,.589,1.071,2.019,2.019,0,0,0,.9.525,4.237,4.237,0,0,0,1.155.146,5.479,5.479,0,0,0,1.47-.209,6.806,6.806,0,0,0,1.386-.546l.126,2.562a8.907,8.907,0,0,1-3.738.714,6.99,6.99,0,0,1-1.659-.21,3.912,3.912,0,0,1-1.575-.8,4.392,4.392,0,0,1-1.176-1.6,6.409,6.409,0,0,1-.462-2.646V8.863H39.059V6.344h4.158V.8h2.772V6.344h5.67Z" fill="#222"/>
                <path d="M55.69,16.928A8.434,8.434,0,0,0,56.4,19.7a7.253,7.253,0,0,0,3.781,3.738,6.783,6.783,0,0,0,2.729.545,7,7,0,0,0,3.844-1.028,7.7,7.7,0,0,0,2.457-2.373l2.141,1.764a10.652,10.652,0,0,1-3.884,3.192,10.868,10.868,0,0,1-4.558.966,10.471,10.471,0,0,1-4.053-.777,9.508,9.508,0,0,1-3.213-2.163,10.247,10.247,0,0,1-2.121-3.276,10.724,10.724,0,0,1-.777-4.116,10.963,10.963,0,0,1,.757-4.116,9.977,9.977,0,0,1,2.1-3.277,9.663,9.663,0,0,1,3.151-2.162,9.77,9.77,0,0,1,3.905-.778,9.575,9.575,0,0,1,3.99.8,8.865,8.865,0,0,1,2.961,2.12,9.076,9.076,0,0,1,1.827,3.109,11.337,11.337,0,0,1,.63,3.8v1.26ZM69.046,14.66a6.291,6.291,0,0,0-1.68-4.557,6.226,6.226,0,0,0-4.7-1.744,6.717,6.717,0,0,0-2.6.525,7.339,7.339,0,0,0-2.2,1.408,7.029,7.029,0,0,0-1.512,2.016,5.186,5.186,0,0,0-.568,2.352Z" fill="#222"/>
                <path d="M76.145,12.476q0-1.3-.064-2.646t-.1-3.486h2.729V10h.084a6.1,6.1,0,0,1,.84-1.534,6.6,6.6,0,0,1,1.323-1.322A6.511,6.511,0,0,1,82.759,6.2a7.114,7.114,0,0,1,2.331-.357,7.52,7.52,0,0,1,2.058.252L86.6,8.821a4.7,4.7,0,0,0-1.6-.21,5.7,5.7,0,0,0-2.73.61,6.075,6.075,0,0,0-1.89,1.554,6.446,6.446,0,0,0-1.113,2.037,6.75,6.75,0,0,0-.357,2.1V26H76.145Z" fill="#222"/>
                <path d="M107.644,16.172a10.724,10.724,0,0,1-.777,4.116,9.743,9.743,0,0,1-5.46,5.439,11.126,11.126,0,0,1-4.221.777,11.008,11.008,0,0,1-4.179-.777,9.743,9.743,0,0,1-5.46-5.439,10.706,10.706,0,0,1-.777-4.116,10.7,10.7,0,0,1,.777-4.116,9.735,9.735,0,0,1,5.46-5.439,10.989,10.989,0,0,1,4.179-.778,11.107,11.107,0,0,1,4.221.778,9.735,9.735,0,0,1,5.46,5.439A10.721,10.721,0,0,1,107.644,16.172Zm-3.024,0a8.839,8.839,0,0,0-.525-3.066,7.387,7.387,0,0,0-1.491-2.478,7.006,7.006,0,0,0-2.332-1.659,8.114,8.114,0,0,0-6.173,0,6.769,6.769,0,0,0-2.31,1.659,7.558,7.558,0,0,0-1.47,2.478,9.212,9.212,0,0,0,0,6.131,7.532,7.532,0,0,0,1.47,2.479,6.769,6.769,0,0,0,2.31,1.659,8.138,8.138,0,0,0,6.173,0,7.006,7.006,0,0,0,2.332-1.659,7.362,7.362,0,0,0,1.491-2.479A8.83,8.83,0,0,0,104.62,16.172Z" fill="#222"/>
              </g>
            </svg>

            <img v-else :src="getPlatformIcon(feedItem.platform)" :alt="feedItem.platform" />
          </q-avatar>

          <!-- Title  or  Author/Handle -->
          <div class="header-text col">
            <template v-if="feedItem.title">
              <div class="text-subtitle2">{{ feedItem.title }}</div>
            </template>
            <template v-else>
              <div class="text-subtitle2">{{ feedItem.author }}</div>
              <div class="text-caption text-grey-6">{{ feedItem.handle }}</div>
            </template>
          </div>

          <q-btn
            flat
            dense
            round
            :icon="props.expanded ? 'expand_less' : 'expand_more'"
            size="sm"
            color="grey-6"
            @click="$emit('toggle-item', feedItem.id)"
            aria-expanded="props.expanded.toString()"
            aria-label="Toggle expand"
          />
          
        </div>
  
        <!-- Content -->
        <div class="q-mt-md">
          <template v-if="feedItem.title && feedItem.author">
            <div class="text-body2 text-italic text-right text-grey-7">
              <template v-if="!props.expanded">{{ feedItem.author }}</template>
              <template v-else>{{ feedItem.allAuthors }}</template>
            </div>
            <br>
          </template>
          <div class="text-body2 content" :class="{ clamped: !props.expanded }" v-html="formattedContent"></div>
        </div>
  
        <!-- Metadata (when expanded) -->
          <div v-if="props.expanded" class="q-mt-md">
            <q-separator class="q-mb-md" />
            <div class="row q-gutter-sm">
              <q-chip
                v-if="feedItem.doi"
                outline
                size="sm"
                color="green-6"
              >
                <q-btn
                  flat
                  dense
                  size="sm"
                  :href="`https://doi.org/${encodeURIComponent(feedItem.doi)}`"
                  target="_blank"
                  rel="noopener"
                  :label="`DOI: ${feedItem.doi}`"
                />
              </q-chip>
              <!-- color="green-6" -->
              <q-chip
                v-if="feedItem.addedByName"
                outline
                size="sm"
              >
                <q-btn
                  flat
                  dense
                  size="sm"
                  :href="`${feedItem.addedByUrl}`"
                  target="_blank"
                  rel="noopener"
                  :label="`Added By: ${feedItem.addedByName}`"
                  no-caps
                />
                <q-tooltip anchor="top middle" self="bottom middle" :delay="200">
                  {{ feedItem.addedByHandle }}
                </q-tooltip>
              </q-chip>
            </div>
            <!-- Keywords -->
            <div v-if="feedItem.keywords.length" class="q-mt-sm">
              <div class="text-caption text-grey-6 q-mb-xs">Keywords:</div>
              <div class="row q-gutter-xs">
                <q-chip
                  v-for="keyword in feedItem.keywords"
                  :key="keyword"
                  size="xs"
                  color="grey-3"
                  text-color="grey-8"
                  :ripple="false"
                >
                  {{ keyword }}
                </q-chip>
              </div>
            </div>
        </div>
  
        <!-- Social engagement -->
        <div class="row items-center justify-between q-mt-md">
          <div class="row q-gutter-sm">

            <q-chip v-if="feedItem.likes !== null" outline size="sm" color="grey-7">
              <q-icon name="thumb_up" size="xs" class="q-mr-xs" />
              {{ formatNumber(feedItem.likes) }}
            </q-chip>
            <q-chip v-if="feedItem.shares !== null" outline size="sm" color="grey-7">
              <q-icon name="share" size="xs" class="q-mr-xs" />
              {{ formatNumber(feedItem.shares) }}
            </q-chip>
            <q-chip v-if="feedItem.comments !== null" outline size="sm" color="grey-7">
              <q-icon name="comment" size="xs" class="q-mr-xs" />
            {{ formatNumber(feedItem.comments) }}
          </q-chip>
          </div>

          <time
            class="text-caption text-grey-6"
            tabindex="0"
            :datetime="timeCreated.toISOString()"
          >
            {{ formattedDate }}
            <q-tooltip anchor="top middle" self="bottom middle" :delay="200">
              {{ timeCreated.toLocaleString() }} 
            </q-tooltip>
          </time>

        </div>
  
        <!-- External link -->
        <div v-if="props.expanded" class="q-mt-md">
          <q-btn
            :href="feedItem.url"
            target="_blank"
            color="primary"
            outline
            size="sm"
            icon="open_in_new"
            label="View Original"
          />
        </div>
      </q-card-section>
    </q-card>
  </template>
  <template v-else>
    <q-card class="social-feed-card">
      <q-card-section class="q-pa-sm">
        <div class="header row items-center justify-between no-wrap">          

          <q-avatar class="platform-icon platform-icon--preview" rounded> 

            <svg v-if="feedItem.platform === 'bluesky'"
              :aria-label="feedItem.platform"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 600 530"
              preserveAspectRatio="xMidYMid meet"
            >
              <title>Bluesky</title>
              <path 
                d="m135.72 44.03c66.496 49.921 138.02 151.14 164.28 205.46 26.262-54.316 97.782-155.54 164.28-205.46 47.98-36.021 125.72-63.892 125.72 24.795 0 17.712-10.155 148.79-16.111 170.07-20.703 73.984-96.144 92.854-163.25 81.433 117.3 19.964 147.14 86.092 82.697 152.22-122.39 125.59-175.91-31.511-189.63-71.766-2.514-7.3797-3.6904-10.832-3.7077-7.8964-0.0174-2.9357-1.1937 0.51669-3.7077 7.8964-13.714 40.255-67.233 197.36-189.63 71.766-64.444-66.128-34.605-132.26 82.697-152.22-67.108 11.421-142.55-7.4491-163.25-81.433-5.9562-21.282-16.111-152.36-16.111-170.07 0-88.687 77.742-60.816 125.72-24.795z" 
                fill="#1185fe"
              />
            </svg>

            <svg v-else-if="feedItem.platform === 'zenodo'"
              :aria-label="feedItem.platform"
              role="img"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 220 80"
              enable-background="new 0 0 220 80"
              xml:space="preserve"
              preserveAspectRatio="xMidYMid meet"
            >
              <title>Zenodo</title>
              <linearGradient id="zenodo-gradient" gradientUnits="userSpaceOnUse" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop stop-color="#0047A8" offset="0"/>
                <stop stop-color="#2BBCFF" offset="1"/>
              </linearGradient>
              <rect x="0" y="0" width="220px" height="80px" fill="url(#zenodo-gradient)" />
              <g transform="translate(36.5, 10)">
                <path 
                  fill="#FFFFFF"
                  d="M145.301,18.875c-0.705-1.602-1.656-2.997-2.846-4.19c-1.189-1.187-2.584-2.125-4.188-2.805 c-1.604-0.678-3.307-1.02-5.102-1.02c-1.848,0-3.564,0.342-5.139,1.02c-0.787,0.339-1.529,0.74-2.225,1.205 c-0.701,0.469-1.357,1.003-1.967,1.6c-0.377,0.37-0.727,0.761-1.051,1.17c-0.363,0.457-0.764,1.068-0.992,1.439 c-0.281,0.456-0.957,1.861-1.254,2.828c0.041-1.644,0.281-4.096,1.254-5.472V2.768c0-0.776-0.279-1.431-0.84-1.965 C120.396,0.268,119.75,0,119.021,0c-0.777,0-1.43,0.268-1.969,0.803c-0.531,0.534-0.801,1.189-0.801,1.965v10.569
                  c-1.117-0.778-2.322-1.386-3.605-1.824c-1.285-0.436-2.637-0.654-4.045-0.654c-1.799,0-3.496,0.342-5.1,1.02 c-1.605,0.679-3,1.618-4.195,2.805c-1.186,1.194-2.139,2.588-2.836,4.19c-0.053,0.12-0.1,0.242-0.15,0.364 c-0.047-0.122-0.094-0.244-0.146-0.364c-0.705-1.602-1.656-2.997-2.846-4.19c-1.189-1.187-2.586-2.125-4.188-2.805 c-1.604-0.678-3.307-1.02-5.102-1.02c-1.848,0-3.564,0.342-5.139,1.02c-1.584,0.679-2.979,1.618-4.191,2.805 c-1.213,1.194-2.164,2.588-2.842,4.19c-0.049,0.115-0.092,0.23-0.137,0.344c-0.047-0.114-0.092-0.229-0.141-0.344
                  c-0.701-1.602-1.65-2.997-2.84-4.19c-1.191-1.187-2.588-2.125-4.193-2.805c-1.604-0.678-3.301-1.02-5.104-1.02 c-1.842,0-3.557,0.342-5.137,1.02c-1.578,0.679-2.977,1.618-4.186,2.805c-1.221,1.194-2.166,2.588-2.848,4.19
                  c-0.043,0.106-0.082,0.214-0.125,0.32c-0.043-0.106-0.084-0.214-0.131-0.32c-0.707-1.602-1.656-2.997-2.848-4.19 c-1.188-1.187-2.582-2.125-4.184-2.805c-1.605-0.678-3.309-1.02-5.104-1.02c-1.85,0-3.564,0.342-5.137,1.02 c-1.467,0.628-2.764,1.488-3.91,2.552V13.99c0-1.557-1.262-2.822-2.82-2.822H3.246c-1.557,0-2.82,1.265-2.82,2.822 c0,1.559,1.264,2.82,2.82,2.82h15.541L0.557,41.356C0.195,41.843,0,42.433,0,43.038v1.841c0,1.558,1.264,2.822,2.822,2.822 h21.047c1.488,0,2.705-1.153,2.812-2.614c0.932,0.743,1.967,1.364,3.109,1.848c1.605,0.684,3.299,1.021,5.102,1.021
                  c2.723,0,5.15-0.726,7.287-2.187c1.727-1.176,3.092-2.639,4.084-4.389v3.805c0,0.778,0.264,1.436,0.805,1.968 c0.531,0.537,1.189,0.803,1.967,0.803c0.73,0,1.369-0.266,1.93-0.803c0.561-0.532,0.838-1.189,0.838-1.968v-9.879h-0.01 c0-0.002,0.01-0.013,0.01-0.013s-6.137,0-6.912,0c-0.58,0-1.109,0.154-1.566,0.472c-0.463,0.316-0.793,0.744-0.982,1.275 l-0.453,0.93c-0.631,1.365-1.566,2.443-2.809,3.244c-1.238,0.803-2.633,1.201-4.188,1.201c-1.023,0-2.004-0.191-2.955-0.579 c-0.941-0.39-1.758-0.935-2.439-1.64c-0.682-0.703-1.227-1.52-1.641-2.443c-0.41-0.924-0.617-1.893-0.617-2.916v-2.476h17.715
                  h1.309h5.539v-8.385c0-1.015,0.191-1.99,0.582-2.912c0.389-0.922,0.936-1.74,1.645-2.444c0.699-0.703,1.514-1.249,2.441-1.641 c0.918-0.388,1.92-0.581,2.982-0.581c1.023,0,2.01,0.193,2.955,0.581c0.945,0.393,1.762,0.938,2.439,1.641 c0.682,0.704,1.225,1.521,1.641,2.444c0.412,0.922,0.621,1.896,0.621,2.912v21.208c0,0.778,0.266,1.436,0.799,1.968 c0.535,0.537,1.191,0.803,1.971,0.803c0.729,0,1.371-0.266,1.934-0.803c0.553-0.532,0.834-1.189,0.834-1.968v-3.803 c0.588,1.01,1.283,1.932,2.1,2.749c1.189,1.189,2.586,2.124,4.191,2.804c1.602,0.684,3.303,1.021,5.102,1.021
                  c1.795,0,3.498-0.337,5.102-1.021c1.602-0.68,3.01-1.614,4.227-2.804c1.211-1.19,2.162-2.589,2.842-4.189 c0.037-0.095,0.074-0.19,0.109-0.286c0.039,0.096,0.074,0.191,0.113,0.286c0.678,1.601,1.625,2.999,2.842,4.189 c1.213,1.189,2.607,2.124,4.189,2.804c1.574,0.684,3.293,1.021,5.139,1.021c1.795,0,3.5-0.337,5.105-1.021 c1.6-0.68,2.994-1.614,4.184-2.804c1.191-1.19,2.141-2.589,2.848-4.189c0.051-0.12,0.098-0.239,0.146-0.36 c0.049,0.121,0.094,0.24,0.146,0.36c0.703,1.601,1.652,2.999,2.842,4.189c1.189,1.189,2.586,2.124,4.191,2.804
                  c1.604,0.684,3.303,1.021,5.102,1.021c1.795,0,3.498-0.337,5.102-1.021c1.604-0.68,3.01-1.614,4.227-2.804 c1.211-1.19,2.16-2.589,2.842-4.189c0.678-1.606,1.02-3.306,1.02-5.104v-10.86C146.355,22.182,146.002,20.479,145.301,18.875z  M7.064,42.06l14.758-19.874c-0.078,0.587-0.121,1.184-0.121,1.791v10.86c0,1.799,0.35,3.498,1.059,5.104 c0.328,0.752,0.719,1.458,1.156,2.119c-0.016,0-0.031-0.001-0.047-0.001H7.064z M42.541,26.817H27.24v-2.841 c0-1.015,0.189-1.99,0.58-2.912c0.391-0.922,0.936-1.74,1.645-2.444c0.697-0.703,1.516-1.249,2.438-1.641
                  c0.922-0.388,1.92-0.581,2.99-0.581c1.02,0,2.002,0.193,2.949,0.581c0.949,0.393,1.764,0.938,2.441,1.641 c0.682,0.704,1.225,1.521,1.641,2.444c0.414,0.922,0.617,1.896,0.617,2.912V26.817z M91.688,34.837 c0,1.023-0.189,1.992-0.582,2.916c-0.389,0.924-0.936,1.74-1.637,2.443c-0.705,0.705-1.523,1.25-2.445,1.64 c-0.92,0.388-1.92,0.579-2.984,0.579c-1.023,0-2.004-0.191-2.955-0.579c-0.945-0.39-1.758-0.935-2.439-1.64 c-0.682-0.703-1.229-1.52-1.641-2.443s-0.617-1.893-0.617-2.916v-10.86c0-1.015,0.191-1.99,0.582-2.912 c0.387-0.922,0.934-1.74,1.639-2.444c0.701-0.703,1.52-1.249,2.441-1.641c0.922-0.388,1.92-0.581,2.99-0.581
                  c1.018,0,2.004,0.193,2.947,0.581c0.951,0.393,1.764,0.938,2.443,1.641c0.68,0.704,1.223,1.521,1.641,2.444 c0.412,0.922,0.617,1.896,0.617,2.912V34.837z M116.252,34.837c0,1.023-0.203,1.992-0.617,2.916 c-0.412,0.924-0.961,1.74-1.641,2.443c-0.68,0.705-1.492,1.25-2.443,1.64c-0.943,0.388-1.93,0.579-2.949,0.579 c-1.07,0-2.066-0.191-2.988-0.579c-0.924-0.39-1.74-0.935-2.439-1.64c-0.707-0.703-1.252-1.52-1.643-2.443 s-0.584-1.893-0.584-2.916v-10.86c0-1.015,0.211-1.99,0.619-2.912c0.416-0.922,0.961-1.74,1.641-2.444 c0.682-0.703,1.496-1.249,2.439-1.641c0.951-0.388,1.934-0.581,2.955-0.581c1.068,0,2.062,0.193,2.986,0.581
                  c0.926,0.393,1.738,0.938,2.443,1.641c0.703,0.704,1.252,1.521,1.641,2.444c0.389,0.922,0.58,1.896,0.58,2.912V34.837z  M140.816,34.837c0,1.023-0.193,1.992-0.58,2.916c-0.393,0.924-0.939,1.74-1.641,2.443c-0.705,0.705-1.523,1.25-2.443,1.64 c-0.922,0.388-1.92,0.579-2.986,0.579c-1.021,0-2.004-0.191-2.955-0.579c-0.943-0.39-1.758-0.935-2.438-1.64 c-0.682-0.703-1.23-1.52-1.643-2.443s-0.619-1.893-0.619-2.916v-10.86c0-1.015,0.193-1.99,0.584-2.912 c0.387-0.922,0.934-1.74,1.639-2.444c0.703-0.703,1.518-1.249,2.441-1.641c0.924-0.388,1.92-0.581,2.99-0.581
                  c1.02,0,2.004,0.193,2.949,0.581c0.949,0.393,1.764,0.938,2.441,1.641c0.682,0.704,1.225,1.521,1.643,2.444 c0.412,0.922,0.617,1.896,0.617,2.912V34.837z"
                />
              </g>
            </svg>

            <svg v-else-if="feedItem.platform === 'zotero'"
              :aria-label="feedItem.platform"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 108 32"
              preserveAspectRatio="xMidYMid meet"
            >
              <title>Zotero</title>
              <g>
                <path d="M15.541,8.359,4.032,23.48H15.96V26H0V23.983L11.507,8.863H.588V6.344H15.541Z" fill="#db2c3a"/>
                <path d="M38.135,16.172a10.743,10.743,0,0,1-.776,4.116,9.743,9.743,0,0,1-5.46,5.439,11.132,11.132,0,0,1-4.222.777,11.006,11.006,0,0,1-4.178-.777,9.743,9.743,0,0,1-5.46-5.439,10.706,10.706,0,0,1-.778-4.116,10.7,10.7,0,0,1,.778-4.116A9.735,9.735,0,0,1,23.5,6.617a10.987,10.987,0,0,1,4.178-.778,11.113,11.113,0,0,1,4.222.778,9.735,9.735,0,0,1,5.46,5.439A10.739,10.739,0,0,1,38.135,16.172Zm-3.023,0a8.816,8.816,0,0,0-.526-3.066A7.355,7.355,0,0,0,33.1,10.628a7,7,0,0,0-2.331-1.659,8.116,8.116,0,0,0-6.174,0,6.775,6.775,0,0,0-2.309,1.659,7.558,7.558,0,0,0-1.47,2.478,9.212,9.212,0,0,0,0,6.131,7.532,7.532,0,0,0,1.47,2.479,6.775,6.775,0,0,0,2.309,1.659,8.141,8.141,0,0,0,6.174,0A7,7,0,0,0,33.1,21.716a7.33,7.33,0,0,0,1.491-2.479A8.807,8.807,0,0,0,35.112,16.172Z" fill="#222"/>
                <path d="M51.659,8.863h-5.67V20.456a6.294,6.294,0,0,0,.21,1.785,2.52,2.52,0,0,0,.589,1.071,2.019,2.019,0,0,0,.9.525,4.237,4.237,0,0,0,1.155.146,5.479,5.479,0,0,0,1.47-.209,6.806,6.806,0,0,0,1.386-.546l.126,2.562a8.907,8.907,0,0,1-3.738.714,6.99,6.99,0,0,1-1.659-.21,3.912,3.912,0,0,1-1.575-.8,4.392,4.392,0,0,1-1.176-1.6,6.409,6.409,0,0,1-.462-2.646V8.863H39.059V6.344h4.158V.8h2.772V6.344h5.67Z" fill="#222"/>
                <path d="M55.69,16.928A8.434,8.434,0,0,0,56.4,19.7a7.253,7.253,0,0,0,3.781,3.738,6.783,6.783,0,0,0,2.729.545,7,7,0,0,0,3.844-1.028,7.7,7.7,0,0,0,2.457-2.373l2.141,1.764a10.652,10.652,0,0,1-3.884,3.192,10.868,10.868,0,0,1-4.558.966,10.471,10.471,0,0,1-4.053-.777,9.508,9.508,0,0,1-3.213-2.163,10.247,10.247,0,0,1-2.121-3.276,10.724,10.724,0,0,1-.777-4.116,10.963,10.963,0,0,1,.757-4.116,9.977,9.977,0,0,1,2.1-3.277,9.663,9.663,0,0,1,3.151-2.162,9.77,9.77,0,0,1,3.905-.778,9.575,9.575,0,0,1,3.99.8,8.865,8.865,0,0,1,2.961,2.12,9.076,9.076,0,0,1,1.827,3.109,11.337,11.337,0,0,1,.63,3.8v1.26ZM69.046,14.66a6.291,6.291,0,0,0-1.68-4.557,6.226,6.226,0,0,0-4.7-1.744,6.717,6.717,0,0,0-2.6.525,7.339,7.339,0,0,0-2.2,1.408,7.029,7.029,0,0,0-1.512,2.016,5.186,5.186,0,0,0-.568,2.352Z" fill="#222"/>
                <path d="M76.145,12.476q0-1.3-.064-2.646t-.1-3.486h2.729V10h.084a6.1,6.1,0,0,1,.84-1.534,6.6,6.6,0,0,1,1.323-1.322A6.511,6.511,0,0,1,82.759,6.2a7.114,7.114,0,0,1,2.331-.357,7.52,7.52,0,0,1,2.058.252L86.6,8.821a4.7,4.7,0,0,0-1.6-.21,5.7,5.7,0,0,0-2.73.61,6.075,6.075,0,0,0-1.89,1.554,6.446,6.446,0,0,0-1.113,2.037,6.75,6.75,0,0,0-.357,2.1V26H76.145Z" fill="#222"/>
                <path d="M107.644,16.172a10.724,10.724,0,0,1-.777,4.116,9.743,9.743,0,0,1-5.46,5.439,11.126,11.126,0,0,1-4.221.777,11.008,11.008,0,0,1-4.179-.777,9.743,9.743,0,0,1-5.46-5.439,10.706,10.706,0,0,1-.777-4.116,10.7,10.7,0,0,1,.777-4.116,9.735,9.735,0,0,1,5.46-5.439,10.989,10.989,0,0,1,4.179-.778,11.107,11.107,0,0,1,4.221.778,9.735,9.735,0,0,1,5.46,5.439A10.721,10.721,0,0,1,107.644,16.172Zm-3.024,0a8.839,8.839,0,0,0-.525-3.066,7.387,7.387,0,0,0-1.491-2.478,7.006,7.006,0,0,0-2.332-1.659,8.114,8.114,0,0,0-6.173,0,6.769,6.769,0,0,0-2.31,1.659,7.558,7.558,0,0,0-1.47,2.478,9.212,9.212,0,0,0,0,6.131,7.532,7.532,0,0,0,1.47,2.479,6.769,6.769,0,0,0,2.31,1.659,8.138,8.138,0,0,0,6.173,0,7.006,7.006,0,0,0,2.332-1.659,7.362,7.362,0,0,0,1.491-2.479A8.83,8.83,0,0,0,104.62,16.172Z" fill="#222"/>
              </g>
            </svg>

            <img v-else :src="getPlatformIcon(feedItem.platform)" :alt="feedItem.platform" />
          </q-avatar>

          <!-- Title  or  Author and part of Content -->
          <div class="header-text col">
            <div class="row items-center justify-between no-wrap">
              <div v-if="feedItem.title" class="only-first-line" :class="$q.screen.lt.md ? 'text-subtitle2' : 'text-subtitle1'">{{ feedItem.title }}</div>
              <div v-else class="only-first-line" :class="$q.screen.lt.md ? 'text-subtitle2' : 'text-subtitle1'">{{ feedItem.author }}</div>
              <time
                class="text-grey-6 time-created"
                :class="$q.screen.lt.md ? 'text-body3' : 'text-caption'"
                tabindex="0"
                :datetime="timeCreated.toISOString()"
              >
                {{ formattedDate }}
              </time>
            </div>
            <div class="two-lines content" :class="$q.screen.lt.md ? 'text-body3' : 'text-body2'" v-html="formattedContent"></div>
          </div>

          

          
          
        </div>
      </q-card-section>
    </q-card>
  </template>
</template>

  <script setup>
  import { computed } from 'vue'
  
  const props = defineProps({
    feedItem: {
      type: Object,
      required: true
    },
    expanded: {
      type: Boolean,
      default: false
    },
    showPreview: {
      type: Boolean,
      default: false
    },
  })
  
  const emit = defineEmits(['toggle-item'])

  const shouldShowReadMore = computed(() => {
    return props.feedItem.content.length > 200
  })
  
  const getPlatformIcon = (platform) => {
    const platformIcons = {
      // twitter: 'fa-brands fa-x-twitter',
      // linkedin: 'fa-brands fa-linkedin',
      // bluesky: 'fa-brands fa-bluesky',
      twitter: 'https://abs.twimg.com/favicons/twitter.3.ico',
      linkedin: 'https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg',
      // bluesky: 'https://bsky.app/static/favicon-32x32.png',
      bluesky: 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/7a/Bluesky_Logo.svg/900px-Bluesky_Logo.svg.png',
      zenodo: 'https://about.zenodo.org/static/img/logos/zenodo-gradient-square.svg',
      // zenodo: 'https://about.zenodo.org/static/img/logos/zenodo-gradient-200.png',
      zotero: 'https://www.zotero.org/static/images/theme/zotero-logo.svg'
    }

    return platformIcons[platform] || 'fas fa-globe'
  }

  const escapeHtml = (inputString) => {
    return inputString
      .split('&').join('&amp;')
      .split('<').join('&lt;')
      .split('>').join('&gt;')
      .split('"').join('&quot;')
      .split("'").join('&#39;')
  }

  const escapeAttr = (inputString) => {
    return inputString
      .split('&').join('&amp;')
      .split('"').join('&quot;')
      .split("'").join('&#39;')
  }

  const getDefaultFormattedContent = (contentText) => {
    const escapedContent = escapeHtml(contentText)
    // Hashtags (#tag) — only at start or after whitespace
    const contentWithHashtags = escapedContent.replace(
      /(^|\s)#([A-Za-z0-9_]+)/g,
      (_fullMatch, leadingWhitespace, hashtagText) =>
        leadingWhitespace + '<span class="hashtag">#' + hashtagText + '</span>'
    )
    // Mentions (@user) — only at start or after whitespace
    const contentWithMentions = contentWithHashtags.replace(
      /(^|\s)@([A-Za-z0-9_]+)/g, 
      (_fullMatch, leadingWhitespace, mentionText) =>
        leadingWhitespace + '<span class="mention">@' + mentionText + '</span>'
    )
    // URLs (basic)
    // const contentWithUrls = contentWithMentions.replace(
    //   /(https?:\/\/[^\s<]+)/g,
    //     (urlMatch) => '<a href="' + escapeAttr(urlMatch)
    //     + '" target="_blank" rel="noopener noreferrer" class="content-link">' + urlMatch + '</a>'
    // )

    const contentWithUrls = contentWithMentions.replace(
      /(https?:\/\/[^\s<]+)/g,
      (urlMatch) => {
        // Remove any trailing punctuation characters
        const match = urlMatch.match(/^(.*?)([)\]\}.,;:!?]+)?$/)
        const cleanUrl = match[1]
        const trailingPunctuation = match[2] || ''
        return (
          '<a href="' + escapeAttr(cleanUrl) +
          '" target="_blank" rel="noopener noreferrer" class="content-link">' +
          cleanUrl + '</a>' + trailingPunctuation
        )
      }
    )


    const formattedContent = contentWithUrls
    return formattedContent
  }

    const buildUtf8ByteToCharIndex = (inputString) => {
    const byteToCharIndexMap = []
    let currentBytePosition = 0

    for (let charIndex = 0; charIndex < inputString.length;) {
      const codePoint = inputString.codePointAt(charIndex)
      const charUnitLength = codePoint > 0xffff ? 2 : 1
      const utf8Length =
        codePoint <= 0x7f ? 1 :
        codePoint <= 0x7ff ? 2 :
        codePoint <= 0xffff ? 3 : 4

      for (let k = 0; k < utf8Length; k++) {
        byteToCharIndexMap[currentBytePosition + k] = charIndex
      }

      currentBytePosition += utf8Length
      charIndex += charUnitLength
    }

    byteToCharIndexMap[currentBytePosition] = inputString.length
    return byteToCharIndexMap
  }

  const getBlueskyFormattedContent = (contentText, facets) => {
    if (facets.length === 0) {
      return escapeHtml(contentText);
    }

    const byteToCharIndexMap = buildUtf8ByteToCharIndex(contentText)
    const sortedFacets = [...facets].sort((a, b) => a.index.byteStart - b.index.byteStart)
    

    let htmlOutput = ''
    let lastCharIndex = 0

    for (const facet of sortedFacets) {
      const startCharIndex = byteToCharIndexMap[facet.index.byteStart] ?? 0
      const endCharIndex = byteToCharIndexMap[facet.index.byteEnd] ?? startCharIndex

      // Plain text chunk before this facet
      htmlOutput += escapeHtml(contentText.slice(lastCharIndex, startCharIndex))

      const visibleFacetText = contentText.slice(startCharIndex, endCharIndex)
      const safeVisibleFacetText = escapeHtml(visibleFacetText)

      let injectedFacetHtml = safeVisibleFacetText
      for (const feature of facet.features || []) {
        if (feature.$type === 'app.bsky.richtext.facet#link' && feature.uri) {
          injectedFacetHtml = '<a href="' + escapeAttr(feature.uri) +
            '" target="_blank" rel="noopener noreferrer" class="content-link">' + safeVisibleFacetText + '</a>'
        }
        if (feature.$type === 'app.bsky.richtext.facet#mention' && feature.did) {
          const profileUrl = encodeURI('https://bsky.app/profile/' + feature.did)
          injectedFacetHtml = '<a href="' + profileUrl +
            '" target="_blank" rel="noopener noreferrer" class="mention">' + safeVisibleFacetText + '</a>'
        }
        if (feature.$type === 'app.bsky.richtext.facet#tag' && feature.tag) {
          const hashtagUrl = encodeURI('https://bsky.app/hashtag/' + feature.tag)
          injectedFacetHtml = '<a href="' + hashtagUrl +
            '" target="_blank" rel="noopener noreferrer" class="hashtag">' + safeVisibleFacetText + '</a>'
        }
      }

      htmlOutput += injectedFacetHtml
      lastCharIndex = endCharIndex
    }

    // Add trailing plain text
    htmlOutput += escapeHtml(contentText.slice(lastCharIndex))
    return htmlOutput
  }

  const sanitizeHtml = (inputHtml) => {
    const allowedTags = new Set([
      'a','p','div','span','b','strong','i','em','u','br','ul','ol','li',
      'table','thead','tbody','tr','td','th','caption','colgroup','col',
      'code','pre','blockquote','h1','h2','h3','h4'
    ])

    // attributes allowed per tag (empty array = allow none)
    const allowedAttrs = {
      'a': ['href','title'],
      'td': ['colspan','rowspan','headers','scope'],
      'th': ['colspan','rowspan','headers','scope'],
      'col': ['span'],
      'div': ['dir'],
      'p': ['dir'],
      'span': ['dir'],
      // global whitelist
      // '*': ['class']
    }

    const isAllowedAttr = (tag, attr) => {
      const list = allowedAttrs[tag] || allowedAttrs['*'] || []
      return list.includes(attr)
    }

    const isSafeUrl = (url) => {
      try {
        const u = new URL(url, window.location.origin)
        return u.protocol === 'http:' || u.protocol === 'https:'
      } catch {
        return false
      }
    }

    const parser = new DOMParser()
    const document = parser.parseFromString(inputHtml, 'text/html')
    const walker = (node) => {
      // Remove dangerous node types outright
      if (node.nodeType === Node.ELEMENT_NODE) {
        const tag = node.tagName.toLowerCase()

        // Drop script/style/iframe/object/embed and any non-whitelisted tag
        if (!allowedTags.has(tag)) {
          node.remove()
          return
        }

        // Strip all attributes except the whitelisted ones (and validate href)
        for (const attr of Array.from(node.attributes)) {
          const name = attr.name.toLowerCase()
          if (!isAllowedAttr(tag, name)) {
            node.removeAttribute(attr.name)
            continue
          }
          if (tag === 'a' && name === 'href' && !isSafeUrl(attr.value)) {
            node.removeAttribute('href')
          }
        }

        // For <a>, enforce safe defaults
        if (tag === 'a' && node.hasAttribute('href')) {
          node.setAttribute('target', '_blank')
          node.setAttribute('rel', 'noopener noreferrer')
        }

        // Recurse children (live list; copy first)
        for (const child of Array.from(node.childNodes)) {
          walker(child)
        }
      }
      else if (node.nodeType === Node.COMMENT_NODE) {
        node.remove()
      }
      // TEXT_NODE is fine as-is
    }

    // sanitize body children into a wrapper div
    for (const child of Array.from(document.body.childNodes)) {
      walker(child);
    }
    // Return sanitized HTML
    return document;
  };

  const getHtmlFormattedContent = (htmlText) => {
    const sanitizedDocument = sanitizeHtml(htmlText)

    // URLs
    sanitizedDocument.body.querySelectorAll('a').forEach((link) => {
      link.classList.add('content-link')
    })

    const sanitizedContent = sanitizedDocument.body.innerHTML;
    if (sanitizedContent.includes('#') || sanitizedContent.includes('@')) {
      const skippedTags = new Set(['a', 'code', 'pre', 'script', 'style'])
      const walker = sanitizedDocument.createTreeWalker(
        sanitizedDocument.body,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode(node) {
            if (!node.nodeValue) return NodeFilter.FILTER_REJECT
            if (node.parentNode && skippedTags.has(node.parentNode.nodeName.toLowerCase())) {
              return NodeFilter.FILTER_REJECT
            }
            if (node.nodeValue.includes('#') || node.nodeValue.includes('@')) {
              return NodeFilter.FILTER_ACCEPT
            }
            return NodeFilter.FILTER_REJECT
          }
        }
      )

      const nodes = []
      let node
      while ((node = walker.nextNode())) nodes.push(node)
      nodes.forEach((textNode) => {
        // Hashtags (#tag) — only at start or after whitespace
        const textWithHashtags = textNode.nodeValue.replace(
          /(^|\s)#([A-Za-z0-9_]+)/g,
          (_fullMatch, leadingWhitespace, hashtagText) =>
            leadingWhitespace + '<span class="hashtag">#' + hashtagText + '</span>'
        )
        // Mentions (@user) — only at start or after whitespace
        const textWithMentions = textWithHashtags.replace(
          /(^|\s)@([A-Za-z0-9_]+)/g, 
          (_fullMatch, leadingWhitespace, mentionText) =>
            leadingWhitespace + '<span class="mention">@' + mentionText + '</span>'
        )
        // Replace the text node with new HTML
        const fragment = sanitizedDocument.createElement('span')
        fragment.innerHTML = textWithMentions
        textNode.replaceWith(...fragment.childNodes)
      })      
    }

    const formattedContent = sanitizedDocument.body.innerHTML
    return formattedContent
  };


  const formattedContent = computed(() => {
    if (props.feedItem.platform === 'bluesky'
        && Array.isArray(props.feedItem.facets)) {
      return getBlueskyFormattedContent(
        props.feedItem.content, props.feedItem.facets
      )
    }
    if (props.feedItem.platform === 'zenodo') {
      return getHtmlFormattedContent(props.feedItem.content)
    }
    return getDefaultFormattedContent(props.feedItem.content)
  });
  
  const formatNumber = (num) => {
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1) + 'M'
    } else if (num >= 1000) {
      return (num / 1000).toFixed(1) + 'K'
    }
    return num.toString()
  };

  const timeCreated = computed(() => {
    return new Date(props.feedItem.timeCreated);
  });

  const formattedDate = computed(() => {
    const now = new Date()
    const diffTime = Math.abs(now - timeCreated.value)
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
    // TODO: add formatting for hours and minutes
    if (diffDays === 1) {
      return '1 day ago'
    } else if (diffDays < 7) {
      return `${diffDays} days ago`
    } else if (diffDays < 30) {
      const weeks = Math.floor(diffDays / 7)
      return `${weeks} week${weeks > 1 ? 's' : ''} ago`
    } else {
      return timeCreated.value.toLocaleDateString()
    }
  });

  </script>
  
  <style scoped>
  .social-feed-card {
    border-radius: 8px;
    transition: all 0.2s ease;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
  }
  
  .social-feed-card--expanded {
    border-left: 4px solid #4CAF50;
  }
  
  :deep(.hashtag) {
    color: #4CAF50;
    font-weight: 600;
  }
  
  :deep(.mention) {
    color: #2196F3;
    font-weight: 600;
  }
  
  :deep(.content-link) {
    color: #FF9800;
    text-decoration: none;
  }
  
  :deep(.content-link:hover) {
    text-decoration: underline;
  }

  /* .text-subtitle2-lg {
    font-size: 0.95rem;
    font-weight: 500;
    line-height: 1.375rem;
    letter-spacing: 0.00714em;
  } */

  .header {
    gap: 8px
  }
  
  .platform-icon {
    width: 42px;
    height: 24px;
    /* padding: 4px;
    margin: 4px; */
    box-sizing: content-box;
  }

  .platform-icon svg {
    max-width: 100%;
    max-height: 100%;
  }

  .platform-icon img {
    object-fit: contain;
  }

  .platform-icon--preview {
    width: 2rem;
    height: 1.125rem;
  }

  .header-text {
    min-width: 0;              /* critical for flex rows */
    overflow-wrap: anywhere;   /* wrap long words/URLs */
    word-break: break-word;
  }

  .time-created {
    white-space: nowrap;
    margin-left: 16px;
  }

  .clamped {
    overflow: hidden;        
    line-clamp: 4;            
    display: -webkit-box;      
    -webkit-box-orient: vertical;  
    -webkit-line-clamp: 4;        
  }

  .only-first-line {
    overflow: hidden;        
    line-clamp: 1;            
    display: -webkit-box;      
    -webkit-box-orient: vertical;  
    -webkit-line-clamp: 1;        
  }

  .two-lines {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-clamp: 2;
  }

  .content {
    overflow-wrap: break-word;
  }

  .content :deep(h1), .content :deep(h2), .content :deep(h3) {
    /* copied from .text-h6 */
    font-size: 1.25rem;
    font-weight: 500;
    line-height: 2rem;
    letter-spacing: .0125em;
  }

  .content :deep(h4), .content :deep(h5), .content :deep(h6) {
    /* copied from .text-subtitle1 and .text-subtitle2 */
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.75rem;
    letter-spacing: .00937em;
  }

  .content :deep(pre) {
    max-width: 100%;
    white-space: pre-wrap
  }

  .content :deep(code) {
    font-size: 0.75rem;
    line-height: 1rem;
  }

  .content :deep(table) { 
    max-width: 100%;
    border-collapse: collapse;
  }

  .content :deep(img) { 
    max-width: 100%;
  }

  </style>